(function () {
	'use strict';
	angular
		.module('rms.common')
		.directive('rankingCandidates', rankingCandidates);

	function rankingCandidates($document) {
		return {
			restrict: 'E',
            controller: rankCandidateCtrl,
            bindToController: true,
            controllerAs: 'apr_ctrl',
			templateUrl: 'common/app/components/ranking-candidates',
			link(scope, elem, attrs, ctrl) {

				scope.sortRankedOptions = {
					cursor : "move",
					connectWith: "#sortableLeft",
					dropOnEmpty:true,
         			scroll:true,
				}

				scope.sortUnRankOptions = {
					cursor : "move",
					connectWith: "#sortableRight",
					dropOnEmpty:true,
         			scroll:true,
				}

    			scope.endRightHandler = function (e) {
	
					// prevent the sortable from modifying the DOM
					if (e.action == 'remove') {
						e.sender._draggable.dropped = true;
						e.sender._defaultPrevented = true;
					}
					if (e.action == 'receive') {
						e._defaultPrevented = true;
						e.sender._defaultPrevented = true;
						var id = e.item[0].id
						scope.apr_ctrl.push_ranked_list(id);
						scope.apr_ctrl.remove_unrank_list(id);
						// update the model and let Angular update the DOM
						var oldIndex = e.oldIndex,
							newIndex = e.newIndex;
						scope.apr_ctrl.ranked_list.splice(
							newIndex, 0, scope.apr_ctrl.ranked_list.splice(oldIndex, 1)[0]
						);
						scope.apr_ctrl.reorderItems();
					}
					if (e.action == 'sort') {
						e.sender._draggable.dropped = true;
						e._defaultPrevented = true;
						// update the model and let Angular update the DOM
						var oldIndex = e.oldIndex,
							newIndex = e.newIndex;
						scope.apr_ctrl.ranked_list.splice(
							newIndex, 0, scope.apr_ctrl.ranked_list.splice(oldIndex, 1)[0]
						);
						scope.apr_ctrl.reorderItems();
					}
						
				};
	
				scope.endLeftHandler = function (e) {
	
					// prevent the sortable from modifying the DOM
					if (e.action == 'remove') {
						e.sender._draggable.dropped = true;
						e.sender._defaultPrevented = true;
					}
					if (e.action == 'receive') {
						e._defaultPrevented = true;
						e.sender._defaultPrevented = true;
						var id = e.item[0].id;
						scope.apr_ctrl.push_unrank_list(id);
						scope.apr_ctrl.remove_ranked_list(id);
						// update the model and let Angular update the DOM					
						var oldIndex = e.oldIndex,
							newIndex = e.newIndex;
						scope.apr_ctrl.unrank_list.splice(
							newIndex, 0, scope.apr_ctrl.unrank_list.splice(oldIndex, 1)[0]
						);
						scope.apr_ctrl.reorderItems();
					}
					if (e.action == 'sort') {
						e.sender._draggable.dropped = true;
						e._defaultPrevented = true;
						// update the model and let Angular update the DOM	
						var oldIndex = e.oldIndex,
							newIndex = e.newIndex;				
						scope.apr_ctrl.unrank_list.splice(
							newIndex, 0, scope.apr_ctrl.unrank_list.splice(oldIndex, 1)[0]
						);
						scope.apr_ctrl.reorderItems();
					}
					
				};
	
				scope.placeholder = function (element) {
					const elementClone = element.clone();
                        elementClone.addClass('sortable-placeholder');
                        elementClone.find('.item-content').html('<div>Drop Here</div>');
                        return elementClone;
				};
				scope.hint = function (element) {
					return element.clone().addClass('sortable-hint');
				};
			}
		}
	}

	function rankCandidateCtrl($scope, lodash, GenericModel) {
        var apr_ctrl = this;
		this.$onInit = function() {
			apr_ctrl.options = lodash.get($scope, '$parent.vm.panelState.structure.options', {});
			apr_ctrl.model = lodash.get($scope, '$parent.vm.panelState.model', {});
			apr_ctrl.unrank_is_empty = false;        
			apr_ctrl.loading = true;
			apr_ctrl.unrank_list = [];
			apr_ctrl.ranked_list = [];
			
			apr_ctrl.remove_unrank_list = remove_unrank_list;
			apr_ctrl.remove_ranked_list = remove_ranked_list;
			apr_ctrl.push_unrank_list = push_unrank_list;
			apr_ctrl.push_ranked_list = push_ranked_list;
			apr_ctrl.unrank_list_exists = unrank_list_exists;
			apr_ctrl.ranked_list_exists = ranked_list_exists;
			apr_ctrl.reorderItems = reorderItems;
			apr_ctrl.clear_ranked_list = clear_ranked_list;
			
			var url = lodash.get(apr_ctrl.options, 'datasource.url', null);
			var method = lodash.get(apr_ctrl.options, 'datasource.method', 'get');
			if (!!url) {
				var resource = GenericModel(url);
				resource[method]({
					selected: lodash.get(apr_ctrl.model, 'selected', []),
					type: lodash.get(apr_ctrl.options, 'type', null),
				}).$promise.then(function(res) {
					apr_ctrl.loading = false;
					apr_ctrl.unrank_list = lodash.get(res, 'unrank_formatted', []);
					apr_ctrl.ranked_list = lodash.get(res, 'ranked_formatted', []);
					lodash.set($scope, 'apr_ctrl.unrank_list',  apr_ctrl.unrank_list);
					lodash.set($scope, 'apr_ctrl.ranked_list',  apr_ctrl.ranked_list);
					
					lodash.set($scope, '$parent.vm.panelState.model.ranked_ids', apr_ctrl.ranked_list.map(function(row) {
						return {id: row.id};
					}));

					apr_ctrl.unrank_is_empty = !(apr_ctrl.unrank_list.length > 0);		
		
				});
			}
		}

		function reorderItems () {
			apr_ctrl.ranked_list = apr_ctrl.ranked_list.map(function(item, index) {
					item.ranking = index + 1;
					return item;
			});


			lodash.set($scope, '$parent.vm.panelState.model.ranked_ids', apr_ctrl.ranked_list.map(function(row) {
				return {id: row.id};
			}));
        }

        function remove_unrank_list(id) {
			// if (unrank_list_exists(id)) {
				lodash.remove(apr_ctrl.unrank_list, {id: id});
				// lodash.set($scope, 'apr_ctrl.unrank_list', apr_ctrl.unrank_list);
			// }
        }

		function remove_ranked_list(id) {
			// if (ranked_list_exists(id)) {
				lodash.remove(apr_ctrl.ranked_list, {id: id});
				// lodash.set($scope, 'apr_ctrl.ranked_list', apr_ctrl.ranked_list);
				
				// lodash.set($scope, '$parent.vm.panelState.model.ranked_ids', apr_ctrl.ranked_list.map(function(id) {
			    //       return {id: id};
		        //   }));
				
			// }
        }
		function push_unrank_list(id) {
			if(!unrank_list_exists(id)) {
				var _obj = apr_ctrl.ranked_list.find(x => x.id === id);
				
				apr_ctrl.unrank_list.push(_obj);

			}
			
		}

		function push_ranked_list(id) {
			if (!ranked_list_exists(id)) {
				var _obj = apr_ctrl.unrank_list.find(x => x.id === id);
				
				apr_ctrl.ranked_list.push(_obj);
	
				// lodash.set($scope, '$parent.vm.panelState.model.ranked_ids', apr_ctrl.ranked_list.map(function(id) {
				// 	return {id: id};
				// }));
			}
		}

		function ranked_list_exists(id) {
			var row = apr_ctrl.ranked_list.find(x => x.id === id);
			
			return row;
		}

		function unrank_list_exists(id) {
			var row = apr_ctrl.unrank_list.find(x => x.id === id);

			return row;
		}

		function clear_ranked_list() {
			apr_ctrl.ranked_list.forEach( function (row) {
				apr_ctrl.unrank_list.push(row);	
			});
			apr_ctrl.ranked_list = [];
			lodash.set($scope, '$parent.vm.panelState.model.ranked_ids',[]);
		}
		
    }

})();